import { State } from '../../types';

export const pennsylvania: State = {
  name: 'Pennsylvania',
  abbreviation: 'PA',
  terms: [
    {
      word: 'Conshohocken',
      phonetic: 'con-sho-HOCK-en',
      // audioUrl: '/audio/conshohocken.mp3',
      description: 'A borough in Montgomery County, its name is derived from the Lenape language, meaning "pleasant valley."'
    },
    {
      word: 'DuBois',
      phonetic: 'doo-BOYS',
      // audioUrl: '/audio/dubois.mp3',
      description: 'A city in Clearfield County, named after its founder, John DuBois.'
    },
    {
      word: 'Duquesne',
      phonetic: 'doo-KANE',
      // audioUrl: '/audio/duquesne.mp3',
      description: 'A city in Allegheny County, named after Fort Duquesne, reflecting its French origins.'
    },
    {
      word: 'Lancaster',
      phonetic: 'LANG-kiss-ter',
      // audioUrl: '/audio/lancaster.mp3',
      description: 'A city in south-central Pennsylvania, pronounced differently from its English namesake.'
    },
    {
      word: 'Lititz',
      phonetic: 'LIT-its',
      // audioUrl: '/audio/lititz.mp3',
      description: 'A borough in Lancaster County, founded by members of the Moravian Church.'
    },
    {
      word: 'Monongahela',
      phonetic: 'muh-NON-gah-HEE-luh',
      // audioUrl: '/audio/monongahela.mp3',
      description: 'A city in Washington County, named after the Monongahela River.'
    },
    {
      word: 'Punxsutawney',
      phonetic: 'punk-suh-TAW-nee',
      // audioUrl: '/audio/punxsutawney.mp3',
      description: 'A borough in Jefferson County, famous for its Groundhog Day celebrations.'
    },
    {
      word: 'Schuylkill',
      phonetic: 'SKOO-kill',
      // audioUrl: '/audio/schuylkill.mp3',
      description: 'A river and county in Pennsylvania, with a name of Dutch origin meaning "hidden river."'
    },
    {
      word: 'Sepviva',
      phonetic: 'Sa-VIVE-a',
      // audioUrl: '/audio/schuylkill.mp3',
      description: 'A street in Philadelphia, with a name rooted in historical local significance.'
    },
    {
      word: 'Susquehanna',
      phonetic: 'susk-wuh-HAN-uh',
      // audioUrl: '/audio/susquehanna.mp3',
      description: 'A river and county in Pennsylvania, with a name derived from the Lenape language.'
    },
    {
      word: 'Versailles',
      phonetic: 'ver-SALES',
      // audioUrl: '/audio/versailles.mp3',
      description: 'A borough in Allegheny County, pronounced differently from the French city.'
    },
    {
      word: 'Wilkes-Barre',
      phonetic: 'wilks-BERRY',
      // audioUrl: '/audio/wilkes-barre.mp3',
      description: 'A city in Luzerne County, named after John Wilkes and Isaac Barré.'
    },
    {
      word: 'Wissahickon',
      phonetic: 'Wiss-a-hick-on (rhymes with chicken)',
      // audioUrl: '/audio/schuylkill.mp3',
      description: 'A creek and wooded valley in Philadelphia, known for its scenic trails and part of Fairmount Park.'
    }
  ]
};